import { useCallback } from 'react';
import { RealtimeAudienceEnum } from 'realtimer/realtimerAudiences';
import { useHubJobOrderLazyQuery } from 'shared/hooks/api/jobOrder/jobOrder.generated';
import { useAuthStore } from 'shared/hooks/stores/useAuthStore';
import { useJobOrdersStore } from 'shared/hooks/stores/useJobOrdersStore';
import { useRealtimer } from 'shared/hooks/useRealtimer';
import { mapDtoToJobOrderListItem } from 'types/JobOrderListItem/mappers';

export const useApplicationStatusRealtimer = () => {
  const expertId = useAuthStore((state) => state.user?.expertId)!;
  const updateListItem = useJobOrdersStore((store) => store.updateListItem);

  const [getJobOrder] = useHubJobOrderLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const handleUpdatedJobOrder = useCallback(async (jobOrderId: string) => {
    if (!jobOrderId) {
      return;
    }
    const res = await getJobOrder({
      variables: {
        jobOrderId,
      },
    });
    const jobOrder = res.data?.jobOrder;
    if (!jobOrder) {
      return;
    }
    const mappedJobOrderListItem = mapDtoToJobOrderListItem(jobOrder);
    updateListItem(jobOrderId, mappedJobOrderListItem);
  }, []);

  useRealtimer(RealtimeAudienceEnum.JobOrderApplicationStatusUpdated, { expertId }, (message) => {
    handleUpdatedJobOrder(message.jobOrderId);
  });
};
